/* Mark <html> for GSAP hero hide-state, removed after animatie speelt */
document.documentElement.classList.add('gsap-anim');

/* VANGNET: animaties draaien alleen als de libs geladen zijn én de bezoeker geen
   'reduce motion' heeft ingesteld. Zo niet: toon alles direct (geen lege pagina). */
var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/* Ronde 4 (okt 2026): scroll-animaties uit, inhoud direct zichtbaar. Zet HELIUS_ANIM op true om ze terug te zetten. */
var HELIUS_ANIM = false;
if (HELIUS_ANIM && window.gsap && window.ScrollTrigger && !prefersReduce) {

gsap.registerPlugin(ScrollTrigger);

/* Lenis smooth-scroll verwijderd — native browser-scrolling is strakker (vooral op desktop/muis).
   ScrollTrigger werkt prima op native scroll; ankerlinks scrollen soepel via CSS scroll-behavior:smooth. */

/* PROGRESS */
gsap.to('#pbar',{ width:'100%', ease:'none', scrollTrigger:{ trigger:document.body, start:'top top', end:'bottom bottom', scrub:.12 }});

/* CURSOR verwijderd — was uitgeschakeld in CSS en kostte onnodig rekenkracht (RAF-loop elke frame). */

/* THREE.JS verwijderd — was ongebruikt: er is geen #hero-canvas in de markup, dus het effect deed niets (scheelt ~600KB download). */
/* FAQ — items en click-handlers worden nu door helius-faq.liquid sectie afgehandeld */

/* WAITLIST — gebruikt nu Shopify's eigen {% form 'customer' %} (native submit) in helius-waitlist.liquid.
   Inschrijvingen komen rechtstreeks in Shopify → Customers. Geen JS-afhandeling meer nodig. */

/* GSAP HERO REVEAL — verwijdert ook de class die headlines tijdelijk verborg */
var htl=gsap.timeline({delay:.3, onStart:function(){ document.documentElement.classList.remove('gsap-anim'); }});
htl.to('.eye-inner',{y:0,duration:.9,ease:'power4.out'})
   .to('.hi',{y:0,duration:1.1,stagger:.14,ease:'power4.out'},'-=.5')
   .to('.hero-feats',{opacity:1,y:0,duration:.8,ease:'power3.out'},'-=.4')
   .to('.hero-btns',{opacity:1,y:0,duration:.85,ease:'power3.out'},'-=.55')
   .to('#sci',{opacity:1,duration:.7},'-=.3');

/* Fallback: als GSAP niet binnen 2.5s actief is, toon headlines toch */
setTimeout(function(){ document.documentElement.classList.remove('gsap-anim'); }, 2500);

/* HERO PIN */
ScrollTrigger.create({
  trigger:'#hero', start:'top top', end:'+=600',
  pin:true, pinSpacing:true,
  onUpdate:function(self){
    var p=self.progress;
    gsap.set('.hero-top',{opacity:Math.max(0,1-p*2.5),y:-p*70});
    gsap.set('#sci',{opacity:Math.max(0,.9-p*3)});
  }
});

/* NAV — scrolled class */
ScrollTrigger.create({
  start:80,
  onUpdate:function(self){ document.getElementById('nav').classList.toggle('scrolled', self.scroller.scrollY > 80); }
});

/* SECTION H2 WORD REVEAL — plain text only, no HTML parsing */
gsap.utils.toArray('.h2').forEach(function(el){
  if(el.closest('#hero')) return;
  var txt=el.textContent.trim();
  var words=txt.split(/\s+/);
  var cl=el.classList.contains('lc')?'lc':'ld';
  el.innerHTML=words.map(function(w){ return '<span class="sw"><span class="si">'+w+'</span></span> '; }).join('');
  el.className='h2 '+cl;
  gsap.to(el.querySelectorAll('.si'),{
    y:0, duration:1.0, stagger:.06, ease:'power4.out',
    scrollTrigger:{trigger:el,start:'top 88%',toggleActions:'play none none reverse'}
  });
});

/* LABELS */
gsap.utils.toArray('.lbl').forEach(function(el){
  if(el.closest('#hero')||el.closest('#waitlist')||el.closest('#products')) return;
  gsap.fromTo(el,{x:-24,opacity:0},{x:0,opacity:1,duration:.75,ease:'power3.out',
    scrollTrigger:{trigger:el,start:'top 90%',toggleActions:'play none none reverse'}
  });
});

/* PRODUCTS */
gsap.utils.toArray('.prod-card').forEach(function(c,i){
  gsap.fromTo(c,{opacity:0,y:60},{opacity:1,y:0,duration:1.1,ease:'power4.out',delay:i*.1,
    scrollTrigger:{trigger:'.products-grid',start:'top 84%',toggleActions:'play none none reverse'}
  });
});

/* NUTRITION */
gsap.fromTo('.nc',{opacity:0,scale:.85,y:40},{opacity:1,scale:1,y:0,
  stagger:{amount:.8,grid:[2,3],from:'center'},duration:1.0,ease:'back.out(1.3)',
  scrollTrigger:{trigger:'.nutr-grid',start:'top 80%'}
});

/* PRINCIPLES */
gsap.utils.toArray('.wm-reason').forEach(function(el,i){
  gsap.fromTo(el,{opacity:0,y:42},{opacity:1,y:0,duration:.9,ease:'power3.out',delay:i*.08,
    scrollTrigger:{trigger:el,start:'top 88%',toggleActions:'play none none reverse'}
  });
});

/* BIG NUMBER */
gsap.fromTo('.wm-bignum',{scale:.5,opacity:0},{scale:1,opacity:1,
  scrollTrigger:{trigger:'.wm-bignum',start:'top bottom',end:'top 28%',scrub:1.6}
});

/* STEPS */
gsap.utils.toArray('.proc-rev').forEach(function(s,i){
  gsap.fromTo(s,{opacity:0,y:20},{opacity:1,y:0,duration:.8,ease:'power3.out',delay:i*.06,
    scrollTrigger:{trigger:'.proc-fig',start:'top 70%',toggleActions:'play none none reverse'}
  });
});

/* VOOR WIE */
gsap.utils.toArray('.vwc').forEach(function(c,i){
  gsap.fromTo(c,{opacity:0,y:44},{opacity:1,y:0,duration:.9,ease:'power3.out',delay:i*.06,
    scrollTrigger:{trigger:'.vw-grid',start:'top 84%',toggleActions:'play none none reverse'}
  });
});

/* REVIEWS */
gsap.fromTo('.rv-card',{opacity:0,y:50},{opacity:1,y:0,stagger:.14,duration:.95,ease:'power3.out',
  scrollTrigger:{trigger:'.rv-grid',start:'top 82%'}
});

/* TEAM */
gsap.utils.toArray('.tm').forEach(function(el,i){
  gsap.fromTo(el,{opacity:0,x:30},{opacity:1,x:0,duration:.85,ease:'power3.out',delay:i*.1,
    scrollTrigger:{trigger:el,start:'top 88%'}
  });
});

/* STATS */
gsap.utils.toArray('.sb-num[data-target]').forEach(function(el){
  var tgt=parseInt(el.dataset.target), sfx=el.dataset.suffix||'';
  ScrollTrigger.create({trigger:el,start:'top 82%',once:true,onEnter:function(){
    gsap.to({v:0},{v:tgt,duration:2,ease:'power2.out',onUpdate:function(){ el.textContent=Math.floor(this.targets()[0].v)+sfx; }});
  }});
});

/* STICKY CTA */
var scta=document.getElementById('scta');
ScrollTrigger.create({
  trigger:'#hero', end:'bottom 40%',
  onLeave:function(){ gsap.to(scta,{y:0,opacity:1,duration:.5,ease:'power3.out'}); },
  onEnterBack:function(){ gsap.to(scta,{y:80,opacity:0,duration:.4}); }
});

} else {
  /* Libs niet geladen of reduce-motion aan: toon alles meteen, sla animaties over. */
  document.documentElement.classList.remove('gsap-anim');
  document.documentElement.classList.add('no-anim');
  /* nav krijgt een donkere achtergrond zodra je scrolt */
  var navEl = document.getElementById('nav');
  var onScroll = function(){ if(navEl) navEl.classList.toggle('scrolled', window.scrollY > 80); };
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
}

/* ===== KORTING POP-UP (toegevoegd) ===== */
(function(){
  var modal=document.getElementById('discountModal');
  if(!modal) return; if(localStorage.getItem('helius_subscribed')) return;
  var inner=document.getElementById('dmInner');
  var success=document.getElementById('dmSuccess');
  var form=document.getElementById('popupForm');
  var email=document.getElementById('dmEmail');
  var closeBtn=document.getElementById('dmClose');
  var skipBtn=document.getElementById('dmSkip');
  var doneBtn=document.getElementById('dmDone');
  function openModal(){ modal.classList.add('show'); document.body.style.overflow='hidden'; setTimeout(function(){ try{email.focus();}catch(e){} },300); }
  function closeModal(){ modal.classList.remove('show'); document.body.style.overflow=''; }

  // De popup komt bij ELKE bezoek naar voren: zodra de bezoeker de site opent
  // (korte vertraging) of bij de eerste scroll — wat het eerst gebeurt. Eén keer per paginaview.
  var opened=false;
  function triggerOnce(){ if(opened) return; opened=true; openModal(); }
  window.addEventListener('scroll', triggerOnce, { once:true, passive:true });
  setTimeout(triggerOnce, 1200);

  // Klik op een product opent 'm ook meteen, zolang hij nog niet getoond is
  // (capture-fase: vangt de klik af vóór de sprong naar #waitlist).
  document.addEventListener('click',function(e){
    var t = e.target && e.target.closest ? e.target.closest('.prod-card, .prod-card .p-btn') : null;
    if(!t) return;        // niet op een product geklikt -> niets doen
    if(opened) return;    // al getoond -> normale link naar #waitlist werkt gewoon
    e.preventDefault();
    e.stopImmediatePropagation();
    triggerOnce();
  }, true);

  closeBtn.addEventListener('click',closeModal);
  skipBtn.addEventListener('click',closeModal);
  if(doneBtn) doneBtn.addEventListener('click',closeModal);
  modal.addEventListener('click',function(e){ if(e.target===modal) closeModal(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && modal.classList.contains('show')) closeModal(); });

  form.addEventListener('submit',function(e){
    e.preventDefault();
    if(!email.value || !email.checkValidity()){ email.reportValidity(); return; }
    var submitBtn = form.querySelector('button[type="submit"]');
    var origText = submitBtn ? submitBtn.innerHTML : null;
    var errEl = document.getElementById('dmErr');
    if(errEl) errEl.hidden = true;
    if(submitBtn){ submitBtn.disabled = true; submitBtn.innerHTML = 'Bezig…'; }

    /* Verstuur het ECHTE Shopify {% form 'customer' %} via AJAX (geen herlaad).
       new FormData(form) bevat alle velden die Shopify zelf genereert, dus de
       inschrijving wordt echt opgeslagen in Shopify → Customers. */
    fetch(form.action, { method:'POST', body: new FormData(form) })
      .then(function(){
        inner.style.display='none';
        success.classList.add('show'); try{localStorage.setItem('helius_subscribed','1');}catch(e){}
      })
      .catch(function(){
        if(errEl) errEl.hidden = false;
      })
      .finally(function(){
        if(submitBtn){ submitBtn.disabled = false; submitBtn.innerHTML = origText; }
      });
  });
})();
